import React from 'react';

class DamagedSKUs extends React.PureComponent {
  componentDidMount() {
    this.loadGrid();
  }

  loadGrid = () => {
    try {
      const damagedSKUsGrid = new Greenmile.RouteSummary.DamagedSKUs.Grid();
      damagedSKUsGrid.init();
    } catch (error) {
      console.log(`${error.message}`)
    }
  }

  render() {
    return (
      <div data-testid="damagedSKUsGrid" id="stockSummaryGrid">
        <div className="gridActions_damaged" />
        <div id="grid_damaged" />
      </div>
    );
  }
}

export default DamagedSKUs;
